// Who may change a company row. MIRRORS the RLS policy "ACCOUNTS/SALES/OPERATIONS can update customers" (20260809b: ADMIN, ACCOUNTS, SALES, OPERATIONS).
// The database is the authority (a role outside this list gets its update silently filtered to 0 rows, no error), so screens use this only to
// avoid offering an edit the user cannot save.
export const CUSTOMER_EDIT_ROLES = ['ADMIN', 'ACCOUNTS', 'SALES', 'OPERATIONS'] as const
export function canEditCustomers(userRoles: readonly string[] | null | undefined): boolean {
  return !!userRoles && userRoles.some(r => (CUSTOMER_EDIT_ROLES as readonly string[]).includes(r))
}
